export const CONSTANTS = {
    KEYS: {
      ENTER: 13
    }
}